import { render, staticRenderFns } from "./storeDetails.vue?vue&type=template&id=70391d82&scoped=true&"
import script from "./storeDetails.vue?vue&type=script&lang=js&"
export * from "./storeDetails.vue?vue&type=script&lang=js&"
import style0 from "./storeDetails.vue?vue&type=style&index=0&id=70391d82&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70391d82",
  null
  
)

export default component.exports